import React from 'react';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';

export const ConnectorForm = props => {
    const [form] = Antd.Form.useForm();

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
    };

    const tailLayout = {
        wrapperCol: { span: 18, offset: 6 },
    };

    return (
        <Antd.Form
            {...layout}
            form={form}
            initialValues={props.initialValues}
            onFinish={values => {
                values.parameters = {};
                for (let p of values.parametersArr) {
                    values.parameters[p.key] = p.value
                }
                delete values.parametersArr;
                if (props.onSuccess) {
                    props.onSuccess(values);
                }
            }}
            onFinishFailed={(err) => {
                console.log(err);
            }}
        >
            {props.initialValues && props.initialValues.id
                ? <Antd.Form.Item name="id" label="ID">
                    <Antd.Input disabled={true} />
                </Antd.Form.Item>
                : null}
            <Antd.Form.Item
                name="code"
                label="Code"
                rules={[{ required: true }]}
            >
                <Antd.Input />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="name"
                label="Name"
                rules={[{ required: true }]}
            >
                <Antd.Input />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="debugMode"
                label="Debug mode"
                rules={[{ required: true }]}
                valuePropName="checked"
            >
                <Antd.Switch />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="type"
                label="Type"
                rules={[{ required: true }]}
            >
                <Antd.Select>
                    <Antd.Select.Option value="sql">SQL</Antd.Select.Option>
                    <Antd.Select.Option value="nosql">No-SQL</Antd.Select.Option>
                </Antd.Select>
            </Antd.Form.Item>
            <Antd.Form.Item
                name="driver"
                label="Driver"
                rules={[{ required: true }]}
                style={{
                    marginBottom: 20
                }}
            >
                <Antd.Select>
                    <Antd.Select.Option value="oracle">Oracle</Antd.Select.Option>
                    <Antd.Select.Option value="postgres">PostgreSQL</Antd.Select.Option>
                    <Antd.Select.Option value="firebird">Firebird</Antd.Select.Option>
                </Antd.Select>
            </Antd.Form.Item>

            <Antd.Typography.Title
                level={5}
            >
                Parameters
            </Antd.Typography.Title>
            <Antd.Form.List
                {...tailLayout}
                name="parametersArr"
            >
                {(fields, { add, remove }) => (
                    <>
                        {fields.map(field => (
                            <Antd.Row
                                gutter={[16, 48]}
                                style={{
                                    marginBottom: 30
                                }}
                            >
                                <Antd.Col
                                    span={23}
                                >
                                    <Antd.Form.Item
                                        label="Key"
                                        name={[field.name, 'key']}
                                        fieldKey={[field.fieldKey, 'key']}
                                        rules={[{ required: true }]}
                                    >
                                        <Antd.Input />
                                    </Antd.Form.Item>
                                    <Antd.Form.Item
                                        label="Value"
                                        name={[field.name, 'value']}
                                        fieldKey={[field.fieldKey, 'value']}
                                        rules={[{ required: true }]}
                                    >
                                        <Antd.Input.TextArea
                                            autoSize={true}
                                        />
                                    </Antd.Form.Item>
                                </Antd.Col>
                                <Antd.Col
                                    span={1}
                                >
                                    <AntdIcons.MinusCircleOutlined onClick={() => remove(field.name)} />
                                </Antd.Col>
                            </Antd.Row>
                        ))}
                        <Antd.Form.Item
                            {...tailLayout}
                        >
                            <Antd.Button type="dashed" onClick={() => add()} block icon={<AntdIcons.PlusOutlined />}>
                                Add parameter
                            </Antd.Button>
                        </Antd.Form.Item>
                    </>
                )}
            </Antd.Form.List>

            <Antd.Form.Item
                {...tailLayout}
            >
                <Antd.Button
                    type="primary"
                    htmlType="submit"
                >
                    Submit
                </Antd.Button>
            </Antd.Form.Item>
        </Antd.Form >
    );
}